import _ from "lodash";
import { getMYPFilterOptionConfigs } from "ToddleLibrary/modules/ToddleLibraryUtils";

export const getFilterMenuOptions = ({
  relatedConcepts,
  difficultyOptions,
  keyConcepts,
  globalContext,
  questionTypeOptions,
  mypSubTopics,
  criterion,
  topics,
  t,
}) => {
  const itemsMap = {
    relatedConcepts,
    difficultyOptions,
    keyConcepts,
    globalContext,
    questionTypeOptions,
    mypSubTopics,
    criterion,
    topics,
  };

  const buildOptions = (
    items,
    { keyPath = "id", labelPath = "label", parent, valuePath, extra = {} }
  ) =>
    _.map(items, item => {
      const key = _.get(item, valuePath || keyPath, "");
      return {
        key,
        value: key,
        label: _.get(item, labelPath, ""),
        parent,
        ...(_.isFunction(extra) ? extra(item, key, t) : extra),
      };
    });

  const FILTER_OPTION_CONFIGS = getMYPFilterOptionConfigs();

  return _.reduce(
    FILTER_OPTION_CONFIGS,
    (acc, config) => {
      const {
        key,
        labelKey,
        itemsKey,
        showIf,
        buildOptionsConfig = {},
      } = config;
      const items = itemsMap[itemsKey] || [];
      const { extra, ...restBuildOptionsConfig } = buildOptionsConfig;

      if (showIf ? showIf(items) : true) {
        acc.push({
          key,
          value: key,
          label: t(labelKey),
          options: buildOptions(items, {
            ...restBuildOptionsConfig,
            extra: _.isFunction(extra)
              ? (item, itemKey) => extra(item, itemKey, t)
              : extra,
          }),
        });
      }
      return acc;
    },
    []
  );
};
